import Helper from '../helper/helper'

import errorAlert from '@/components/errorAlert'
import linkComponent from '@/components/elements/link'

import store from '../store'
import router from '../router'
///////////////////////////////////////////////////////////////////////////////
// работа с формами
///////////////////////////////////////////////////////////////////////////////
const formsPlugin = {
	//=========================================================================
	// установка плагина - обязательная функция
	//=========================================================================
	install(Vue, options) {
		//---------------------------------------------------------------------
		// стилизация
		//---------------------------------------------------------------------
		Vue.stylePathToLogo = process.env.LOGO_PATH
		Vue.stylePathToLogoText = process.env.LOGO_TEXT_PATH
		Vue.stylePathToLoader = process.env.LOADER_PATH

		//---------------------------------------------------------------------
		// адреса серверов
		//---------------------------------------------------------------------
		Vue.APIServerUrl = process.env.API_SERVER
		Vue.PushUrl = process.env.PUSH_SERVER + '/sub'
		Vue.AppServerUrl = process.env.WEB_SERVER
		Vue.QAUrl = process.env.QA_SERVER

		Vue.CookieDomain = process.env.COOKIE_DOMAIN || '.vdsina.ru'

		Vue.AppName = process.env.APP_NAME || 'vdsina'

		Helper.SmallAmounts = false
		if (Vue.AppName === 'vdsina.com' ||
			(Vue.AppName === 'macloud' && process.env.NODE_ENV === 'development'))
		{
			Helper.SmallAmounts = true
		}

		// режим дебага
		store.commit('debugMode', process.env.NODE_ENV === 'development')

		// адрес панели
		Vue.CpServerUrl = window.location.protocol + '//' + window.location.host

		// версия приложения
		Vue.AppVersion = '207'

		// константы для бэкапа
		Vue.TypeBackupDialog_create = 'create-backup'

		//---------------------------------------------------------------------
		// константы услуг глобально
		//---------------------------------------------------------------------
		Vue.Constants = {
			SERVICE_TYPE_VDS: 1,
			SERVICE_TYPE_VDS_IP4: 2,
			SERVICE_TYPE_VDS_IP6: 7,
			SERVICE_TYPE_VDS_RAM: 3,
			SERVICE_TYPE_VDS_SSD: 4,
			SERVICE_TYPE_VDS_CPU: 5,
			SERVICE_TYPE_VDS_TRAFF: 6,
			SERVICE_TYPE_VDS_LOAD: 8,
			SERVICE_TYPE_VDS_SNAPSHOT: 9,
			SERVICE_TYPE_ISO: 10,
			SERVICE_TYPE_SSL: 11,
			SERVICE_TYPE_DOMAIN: 12,
			SERVICE_TYPE_DOMAIN_PRIVACY: 13,
			SERVICE_TYPE_DNS: 14,
			SERVICE_TYPE_BACKUP_VDS: 15,
			SERVICE_TYPE_EXTDISK_HDD: 16,
			SERVICE_TYPE_EXTDISK_NVME: 17,
			SERVICE_TYPE_RESERVE_IP: 18,
			SERVICE_TYPE_GPU: 19,
			VALID_IMAGE_EXT: {
				'gif': true,
				'jpg': true,
				'jpeg': true,
				'png': true,
				'bmp': true
			},
			VDS_GROUP: {
				'vds': 1,
				'hi-cpu-vds': 12
			}
		}

		//---------------------------------------------------------------------
		// добавляем интерсептор
		//---------------------------------------------------------------------
		Vue.http.interceptors.push((request, next) => {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если приложение блокировано - никакой сетевой активности
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (store.state.applicationBlocked) return

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// для CORS
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			request.credentials = true

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// увеличиваем счетчик запросов
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			store.commit('operateAjaxRequestsCounter', 1)

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если можно показывать блок лоадера долгой загрузки
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (store.state.showLongLoader)
			{
				// запланируем показ блока с лоадером через 400 мс
				setTimeout(() => {
					// если он и так видим - ничего не делаем, закрывается он в другом месте
					if (store.state.longRequest) return
					// если есть активные запросы
					if (store.state.ajaxRequestsCounter > 0)
						store.commit('hideLongRequestLoader', true)
				}, 400)
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// обработаем конец ответа
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			next((response) => {
				// уменьшаем счетчик запросов
				store.commit('operateAjaxRequestsCounter', -1)

				// если уже нет активных запросов
				if (store.state.ajaxRequestsCounter <= 0)
				{
					// закрываем блок с лоадером через паузу, что бы не моргало
					setTimeout(() => {
						store.commit('hideLongRequestLoader', false)
					}, 400)
				}

				// в итоге смотрим статус
				if (response.status === 400)
				{
					// такая ошибка может быть например при блокировке кук в браузере
					// запоминаем URL, что бы к нему вернуться
					store.commit('setReturnURL', window.location.pathname)
					// сохраним код ошибки
					store.commit('errorHttpCode', 400)
					// редирект на страницу с текстом ошибки
					router.push('/500')
				}
				// если слетела авторизация
				else if (response.status === 401)
				{
					// аутентификация протухла
					store.commit('dropAuth')
					// запоминаем URL, что бы к нему вернуться
					store.commit('setReturnURL', window.location.pathname)
					// остановим Push-систему
					store.commit('pushStop')
					// редирект на страницу аутентификации
					router.push('/login')
				}
				// если доступ запрещен
				else if (response.status === 403)
				{
					if (store.state.is_auth)
					{
						// если это ошибка - "доступ запрещен к какому то ресурсу"
						if ((response.data && response.data.content && String(response.data.content).indexOf('user_forbidden') > 0) ||
							!Helper.verifyPermissions(store.state.user_role, router.currentRoute))
						{
							// ничего не делаем - ошибку отрисует активный дочерний компонент
							return
						}
						// сохраним код ошибки
						store.commit('errorHttpCode', response.status)
						// редирект на страницу с текстом ошибки
						router.push('/500')
					}
					else
					{
						// аутентификации и так нет, но подстрахуемся
						store.commit('dropAuth')
						// остановим Push-систему
						store.commit('pushStop')
						// если это 403 Blacklisted
						if (response.data && response.data.content === 'Blacklisted')
						{
							// do nothing
							return
						}

						// редирект на страницу аутентификации
						router.push('/login')
					}
				}
				// если не найдено
				else if (response.status === 404)
				{
					// сохраним код ошибки
					store.commit('errorHttpCode', response.status)
					// редирект на страницу с текстом ошибки
					router.push('/404')
				}
				// если какая то другая ошибка сервера
				else if (response.status >= 400)
				{
					// если пользователь авторизован
					if (store.state.is_auth)
					{
						// нет проверки только на 503 ошибку
						if (response.status === 503)
						{
							// запоминаем URL, что бы к нему вернуться
							store.commit('setReturnURL', window.location.pathname)
							// сохраним код ошибки
							store.commit('errorHttpCode', 503)
							// редирект на страницу с текстом ошибки
							router.push('/503')
						}
						else
						{
							// здесь ничего не делаем - ошибку подхватит тот кто произвел запрос
						}
					}
					// если пользователь не авторизован - редирект на 503 при любой ошибке
					else
					{
						// если это 511 Need 2FA Verify
						if (response.status === 511 && response.data && response.data.content === 'Need 2FA Verify')
							// do nothing
							return

						// запоминаем URL, что бы к нему вернуться
						store.commit('setReturnURL', window.location.pathname)
						// сохраним код ошибки
						store.commit('errorHttpCode', 503)
						// редирект на страницу с текстом ошибки
						router.push('/503')
					}
				}
				// если нет соединения
				else if (response.status <= 0)
				{
					// тут нужно понять - когда нет интернета или когда мы сами оборвали запрос !!!!!
					// location.reload(true)
				}
			})

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		})

		//---------------------------------------------------------------------
		// mixin'ы
		//---------------------------------------------------------------------
		Vue.mixin({
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// Это данные приложения
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			data() {
				return {
					AppName: Vue.AppName,

					form_ErrorMessage: false,
					form_Loading: false,
					form_GetData: false,
					form_PostData: false,
					// видимость левого меню
					sideMenuVisible: false,
					// URL API-сервера
					APIServerUrl: Vue.APIServerUrl,
					// флаг - это мы прервали запрос или нет?
					itIsOurAbort: false,
					// адрес панели
					CpServerUrl: Vue.CpServerUrl,
					// флаг начала клика (mousedown) по маске модального диалога
					maskModalFlag: false,

					// стилизация
					stylePathToLogo: Vue.stylePathToLogo,
					stylePathToLogoText: Vue.stylePathToLogoText,
					stylePathToLoader: Vue.stylePathToLoader,

					// ошибка капчи
					form_ErrorCaptchaMessage: false
				}
			},

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// используемые везде компоненты
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			components: {
				errorAlert,
				linkComponent
			},

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// этот метод будет доступен из любого компонента
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			methods: {
				//=============================================================
				// перезагрузка приложения
				//=============================================================
				softReloadApp() {
					location.reload()
				},

				//=============================================================
				// кеш данных форм
				//=============================================================
				getFormFromCache(formUrl) {
					return new Promise(async (resolve) => {
						// нужно ли запрашивать форму
						let needRequest = false

						// получим кеш форм
						const cache = this.$store.state.lastFormCache

						// если нет кеша указанной формы
						if (!cache ||
							!cache[formUrl] ||
							!cache[formUrl]['data'] ||
							!cache[formUrl]['ttl'])
						{
							// нужен запрос
							needRequest = true
						}

						// если кеш есть
						if (!needRequest)
						{
							// но он просрочен
							const ttl = cache[formUrl]['ttl']
							if (ttl < new Date().getTime())
							{
								// удалим старый кеш
								this.$store.commit('clearFormCache', formUrl)
								// нужен запрос
								needRequest = true
							}
						}

						// если запрос так и не нужен
						if (!needRequest) return resolve(cache[formUrl]['data'])

						// запрос нужен
						try {
							const response = await this.$http.get(Vue.APIServerUrl + formUrl)
							const _dt = response && response.body && typeof response.body === 'object' ? response.body : false

							if (_dt && _dt['status'] === 'form' && _dt['fields'])
							{
								// запомним данные
								this.$store.commit('saveFormCache', {
									formName: formUrl,
									data: _dt
								})

								// вернем данные
								return resolve(_dt)
							}
						}
						catch (err) {
							// если это 403 Blacklisted
							if (err && err.status === 403 && err.body && err.body.content === 'Blacklisted')
							{
								return resolve({ status: 'error', message: 'login/blacklisted' })
							}

							return resolve(err)
						}

						// если что то не так
						resolve(null)
					})
				},

				//=============================================================
				// Настоящее название CRUD
				//=============================================================
				__realCrudName(crud) {
					// определим частные случаи
					if (crud === 'admin') return 'user'
					if (crud === 'partnerprogram') return 'program'
					if (crud === 'servicetype') return 'service_type'
					if (crud === 'planarchive') return 'plan'
					if (crud === 'additional-services' ||
						crud === 'iso' || crud === 'certificate' ||
						crud === 'domains' || crud === 'dns' ||
						crud === 'backups' ||
						crud === 'disks')
						return 'service'

					// если это общий случай
					return crud
				},

				//=============================================================
				// добавляет элементу класс "className"
				//=============================================================
				addClass(el, className) {
					if (!className) return
					if (el && el.className && el.className.indexOf(className) === -1)
					{
						el.className += ' ' + className
					}
				},

				//=============================================================
				// удаляет у элемента класс "className"
				//=============================================================
				removeClass(el, className) {
					if (!className) return
					if (el && el.className && el.className.indexOf(className) !== -1)
					{
						el.className = el.className.replace(new RegExp('\\s*' + className + '\\s*', 'gi'), '')
					}
				},

				//=============================================================
				// обработка клавиши на поле
				//=============================================================
				enterOnInput(e) {
					if (e && e.keyCode === 13)
					{
						this.$refs['button'].click()
					}
				},

				//=============================================================
				// убирает с родителя поля класс "has-error"
				//=============================================================
				removeErrorBorder_OnFocus(e) {
					let _parent = e && e.target ? e.target.parentNode : null
					if (_parent) this.removeClass(_parent, 'has-error')
				},

				//=============================================================
				// функция получает ширину окна браузера и показывает/скрывает
				// мобильное левое меню
				//=============================================================
				hideModalMask() {
					let _masks = document.querySelectorAll('div.modal-mask')
					for (let i = 0; i < _masks.length; i++)
					{
						let _style = window.getComputedStyle(_masks[i])
						if (_style.display !== 'none' && _style.visibility !== 'hidden')
						{
							_masks[i].style.display = 'none'
							return true
						}
					}

					return false
				},

				//=============================================================
				// функция получает ширину окна браузера и показывает/скрывает
				// мобильное левое меню
				//=============================================================
				getWindowWidth(event) {
					let windowWidth = document.documentElement.clientWidth
					let windowHeight = document.documentElement.clientHeight
					store.commit('setWindowSize', { 'width': windowWidth, 'height': windowHeight })

					if (windowWidth <= 767)
						this.sideMenuVisible = false
					else
						this.sideMenuVisible = true
				},

				//=============================================================
				// получает координаты заданного элемента
				//=============================================================
				getElementOffset(el, elementOnly = false) {
					let rect = el.getBoundingClientRect()
					if (elementOnly) return { top: rect.top, left: rect.left }

					let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
					let scrollTop = window.pageYOffset || document.documentElement.scrollTop

					return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
				},

				//=============================================================
				// возвращает настоящее наименование CRUD
				//=============================================================
				getRealCrud(crud) {
					if (crud === 'vds' ||
						crud === 'hi-cpu-vds' ||
						crud === 'iso' ||
						crud === 'additional-services' || crud === 'domains' || crud === 'backups' ||
						crud === 'certificate' ||
						crud === 'dns' ||
						crud === 'disks')
						return 'service'
					if (crud === 'planarchive') return 'plan'
					if (crud === 'dns-records') return 'dns'

					// по умолчанию - такой же
					return crud
				},

				//=============================================================
				// обработка ошибки запроса
				//=============================================================
				formatRequestError(res) {
					// это ошибка по умолчанию
					let _errMsg = 'error/http_error'

					// если заданы ошибки для полей
					if (res && res.data && typeof res.data === 'object' &&
						'fields' in res.data && res.data['fields'] && typeof res.data['fields'] === 'object' &&
						Object.keys(res.data['fields']).length &&
						res.data.status !== 'form')
					{
						// соберем все ошибки
						_errMsg = ''
						for (let prop in res.data['fields']) if (res.data['fields'].hasOwnProperty(prop))
						{
							// получим поле
							let _field = res.data['fields'][prop]
							// могут быть пустые ошибки
							if (_field)
							{
								// получим саму ошибку
								let _txt = ''
								if (Array.isArray(_field) && _field.length) _txt = _field[0]
								else if (typeof _field === 'object') _txt = 'error/unknown'
								else _txt = String(_field)

								// суммируем
								if (_txt && _txt !== '')
								{
									if (_errMsg === '') _errMsg = _txt
									else _errMsg += ' <br> ' + _txt
								}
							}
						}

						// если что то получили - возвращаем результат
						if (_errMsg !== '') return _errMsg
					}

					if (res && res.data && typeof res.data === 'object' &&
						'title' in res.data && res.data['title'] && res.data['title'].length)
						_errMsg = 'main/error_desc ' + res.data['title']

					if (res && res.data && typeof res.data === 'object' &&
						'content' in res.data && res.data['content'] && res.data['content'].length)
						_errMsg = 'main/error_desc ' + res.data['content']

					return _errMsg
				},

				//=============================================================
				// запрос проверки значения поля
				//=============================================================
				forms_verifyRequest: function(url, params, callback, beforeFunc) {
					// не нужно показывать лоадер
					store.commit('needShowLoader', false)

					// начинаем запросы
					this.$http.get(url, {
						before(reqGet) {
							if (beforeFunc && typeof beforeFunc === 'function')
								beforeFunc(reqGet)
						}
					}).then(
						// только успешный результат
						response => {
							// только положительный корректный ответ
							let _data = response.data
							if (_data && _data['status'] === 'form' && _data['model'] && _data['_csrf'])
							{
								// можно формировать второй запрос
								let _sendData = {}
								_sendData['_csrf'] = _data['_csrf']
								_sendData['_validate'] = params['field']
								_sendData[_data['model']] = {}
								_sendData[_data['model']][params['field']] = params['value']
								if (params['data'] && Object.keys(params['data']).length)
									_sendData[_data['model']] = Object.assign({}, _sendData[_data['model']], params['data'])

								// второй запрос
								this.$http.post(url, Helper.toFormData(_sendData), {
									before(reqPost) {
										if (beforeFunc && typeof beforeFunc === 'function')
											beforeFunc(reqPost)
									}
								}).then(
									// успешный ответ
									res => {
										// сразу разрешаем показ лоадера запросов
										store.commit('needShowLoader', true)
										// рассматриваем только сообщения об ошибке
										let _data = res.data
										if (_data && _data['status'] === 'error' &&
											callback && typeof callback === 'function')
											callback(_data)
									},
									// провальный ответ
									() => store.commit('needShowLoader', true)
								)
							}
						},
						// провальный ответ
						() => store.commit('needShowLoader', true)
					)
				},

				//=============================================================
				// одиночный GET-запрос к АПИ-серверу
				//=============================================================
				forms_Get: function(url, data, callbackSuccess, callbackFail) {
					//---------------------------------------------------------
					// старт запроса - готовим переменные
					//---------------------------------------------------------
					this.form_Loading = true
					this.form_ErrorMessage = false

					this.form_GetData = false
					this.form_PostData = false

					//---------------------------------------------------------
					// делаем сам запрос
					//---------------------------------------------------------
					this.$http.get(this.APIServerUrl + url, {
						'params': data,
						// определим колбак "before"
						before(request) {
							this.itIsOurAbort = false
							// если есть конкретный запрет на прерывание в параметрах
							if (data && data['dontAbort'] === true)
							{
								delete data['dontAbort']
								return
							}
							// если есть предыдущий запрос - прервем его
							if (this.previousRequest)
							{
								this.itIsOurAbort = true
								this.previousRequest.abort()
							}
							// установим в предыдущий запрос - текущий
							this.previousRequest = request
						}
					}).then(
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// успешный ответ
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						response => {
							// если клиенты запрашивают список партнерств
							if (url.indexOf('/partner/list') === 0 && store.state.user_type === 'client')
							{
								// добавим всем строкам поле статус и соберем активные программы в список
								let _listId = {}
								for (let l = 0; l < response.data.rows.length; l++)
								{
									response.data.rows[l]['status'] = true
									_listId[response.data.rows[l].program_id] = true
								}

								// теперь нужно определить - запрошена последняя страница?
								// 1. текущая страница
								let _curPage = this.$route && this.$route.params && this.$route.params.page
									? this.$route && this.$route.params && this.$route.params.page : 1
								_curPage = parseInt(_curPage)
								if (isNaN(_curPage)) _curPage = 1
								// 2. общее количество страниц
								let _pageCount = 1
								let _total = 0
								let _size = 0
								if (response && response.data && response.data.totalCount && response.data.pageSize)
								{
									_total = parseInt(response.data.totalCount)
									_size = parseInt(response.data.pageSize)
									if (!isNaN(_total) && !isNaN(_size) && _size > 0)
										_pageCount = Math.ceil(_total / _size)
								}
								// 3. добавим неактивные программы только на последную страницу
								if (_curPage === _pageCount)
								{
									// нужно запросить список неактивированных партнерств
									this.$http.get(this.APIServerUrl + '/partner/create').then(
										response2 => {
											if (response2 && response2.data && typeof response2.data === 'object' && response2.data.fields && response2.data.status === 'form')
											{
												let programs = response2.data.fields.program_id.list
												let accountId = parseInt(response2.data.fields.account_id.value)
												let _addCount = 0

												// теперь добавим в массив строк неактивированные партнерства
												for (let programId in programs) if (programs.hasOwnProperty(programId))
												{
													// если такая программа уже есть в списке - пропускаем
													if (programId in _listId) continue

													// считаем количество неактивных программ
													_addCount++

													// если нет - добавим
													response.data.rows.push({
														program_id: parseInt(programId),
														program_name: programs[programId],
														p2a_code: '',
														p2a_id: 10000000 + _total + _addCount,
														account_id: accountId,
														status: false,
														can_delete: false
													})
												}

												// установим новые данны
												response.data.additionalTotalCount = _addCount
											}

											// сетевая активность завершена
											this.form_Loading = false
											// запоминаем данные
											this.form_GetData = response.data
											// вызов колбака с данными
											if (callbackSuccess && typeof callbackSuccess === 'function') callbackSuccess(response.data)
										}
									)

									// на этом все
									return
								}
							}

							// сетевая активность завершена
							this.form_Loading = false
							// запоминаем данные
							this.form_GetData = response.data
							// вызов колбака с данными
							if (callbackSuccess && typeof callbackSuccess === 'function') callbackSuccess(response.data)
						},
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// отрицательный ответ
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						response => {
							// если это мы прервали - ничего не делаем
							if (this.itIsOurAbort && response.status === 0) return

							// это ошибка
							let _errMsg = this.localeFtc('error/http_error')
							if (response.data && typeof response.data === 'object' &&
								'title' in response.data && response.data['title'] && response.data['title'].length)
								_errMsg = this.localeFtc('main/error_desc') + ' ' + this.localeFtc(response.data['title'])
							if (response.data && typeof response.data === 'object' &&
								'content' in response.data && response.data['content'] && response.data['content'].length)
								_errMsg = this.localeFtc('main/error_desc') + ' ' + this.localeFtc(response.data['content'])

							this.form_Loading = false
							this.form_ErrorMessage = _errMsg
							if (callbackFail && typeof callbackFail === 'function') callbackFail(response)
						}

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					)

					//---------------------------------------------------------
				},

				//=============================================================
				// двойной запрос к АПИ-серверу
				//=============================================================
				forms_GetThenPost: function(url, data, callbackSuccess, callbackFail) {
					// старт запроса
					this.form_Loading = true
					this.form_ErrorMessage = false

					this.form_GetData = false
					this.form_PostData = false

					// первый запрос - GET, что бы получить csrf-код
					this.$http.get(Vue.APIServerUrl + url).then(
						// успешный ответ
						response => {
							// запоминаем ответ на GET-запрос
							this.form_GetData = response.data
							// может сразу прийти положительный ответ
							if (response.data && typeof response.data === 'object' && 'status' in response.data && response.data['status'] === 'ok')
							{
								// сетевая активность завершена
								this.form_Loading = false
								// вызов колбака с данными
								if (callbackSuccess && typeof callbackSuccess === 'function') callbackSuccess(response.data)
								return
							}

							// разбор ответа
							if (response.data && typeof response.data === 'object' && '_csrf' in response.data && response.data._csrf)
							{
								// формируем объект для передачи
								let _sendData = {}
								// если задан параметр
								if (data)
								{
									// если задана модель
									if ('model' in response.data && response.data.model)
										_sendData[response.data.model] = data
									else
										_sendData = data
								}
								// добавляем csrf-код
								_sendData['_csrf'] = response.data._csrf

								// делаем второй запрос
								this.$http.post(Vue.APIServerUrl + url, Helper.toFormData(_sendData)).then(
									// успешный ответ
									postData => {
										let _postData = postData && postData.data && typeof postData.data === 'object' ? postData.data : false
										// ответ утвердительный
										if (_postData && 'status' in _postData && _postData.status === 'ok')
										{
											// запоминаем ответ на POST-запрос
											this.form_PostData = _postData
											// сетевая активность завершена
											this.form_Loading = false
											// вызов колбака с данными
											if (callbackSuccess && typeof callbackSuccess === 'function') callbackSuccess(_postData)
											return
										}
										// ошибки полей
										else if (_postData && 'status' in _postData && _postData.status === 'error' &&
											'fields' in _postData && _postData.fields)
										{
											this.form_Loading = false
											if (callbackFail && typeof callbackFail === 'function') callbackFail(_postData.fields)
											return
										}

										// ответ вообще не тот - ошибка
										let _errMsg = this.localeFtc('error/http_error')
										if (_postData && typeof _postData === 'object' &&
											'title' in _postData && _postData['title'] && _postData['title'].length)
											_errMsg = this.localeFtc('main/error_desc') + ' ' + this.localeFtc(_postData['title'])
										if (_postData && typeof _postData === 'object' &&
											'content' in _postData && _postData['content'] && _postData['content'].length)
											_errMsg = this.localeFtc('main/error_desc') + ' ' + this.localeFtc(_postData['content'])

										this.form_Loading = false
										this.form_ErrorMessage = _errMsg
										if (callbackFail && typeof callbackFail === 'function') callbackFail(postData)
									},
									// отрицательный ответ
									postData => {
										let _postData = postData && postData.data && typeof postData.data === 'object' ? postData.data : false
										// ответ не тот - ошибка
										let _errMsg = this.localeFtc('error/http_error')
										if (_postData && typeof _postData === 'object' &&
											'title' in _postData && _postData['title'] && _postData['title'].length)
											_errMsg = this.localeFtc('main/error_desc') + ' ' + this.localeFtc(_postData['title'])
										if (_postData && typeof _postData === 'object' &&
											'content' in _postData && _postData['content'] && _postData['content'].length)
											_errMsg = this.localeFtc('main/error_desc') + ' ' + this.localeFtc(_postData['content'])

										this.form_Loading = false
										this.form_ErrorMessage = _errMsg
										if (callbackFail && typeof callbackFail === 'function') callbackFail(postData)
									}
								)
								return
							}

							// ответ не тот - ошибка
							let _errMsg = this.localeFtc('error/http_error')
							if (response.data && typeof response.data === 'object' &&
								'title' in response.data && response.data['title'] && response.data['title'].length)
								_errMsg = this.localeFtc('main/error_desc') + ' ' + this.localeFtc(response.data['title'])
							if (response.data && typeof response.data === 'object' &&
								'content' in response.data && response.data['content'] && response.data['content'].length)
								_errMsg = this.localeFtc('main/error_desc') + ' ' + this.localeFtc(response.data['content'])

							this.form_Loading = false
							this.form_ErrorMessage = _errMsg
							if (callbackFail && typeof callbackFail === 'function') callbackFail(response)
						},
						// отрицательный ответ
						response => {
							// это ошибка
							let _errMsg = this.localeFtc('error/http_error')
							if (response.data && typeof response.data === 'object' &&
								'title' in response.data && response.data['title'] && response.data['title'].length)
								_errMsg = this.localeFtc('main/error_desc') + ' ' + this.localeFtc(response.data['title'])
							if (response.data && typeof response.data === 'object' &&
								'content' in response.data && response.data['content'] && response.data['content'].length)
								_errMsg = this.localeFtc('main/error_desc') + ' ' + this.localeFtc(response.data['content'])

							this.form_Loading = false
							this.form_ErrorMessage = _errMsg
							if (callbackFail && typeof callbackFail === 'function') callbackFail(response)
						}
					)
				},

				//=============================================================
				// событие: меняется значение поля формы
				//=============================================================
				onFormFieldChanged(field, formData) {
					if (field && typeof field === 'object') field['_errMsg'] = ''
					this.form_ErrorMessage = false
				},

				//=============================================================
				// событие: фокус на поле формы
				//=============================================================
				onFormFocus(field, formData) {
					this.form_ErrorMessage = false

					if (field && typeof field === 'object') field['_errMsg'] = ''

					if (formData &&
						formData.fields &&
						Array.isArray(formData.fields) &&
						formData.fields.length)
					{
						formData.fields.forEach(item => {
							if (item && Array.isArray(item) && item.length)
							{
								item.forEach(obj => {
									if (obj && typeof obj === 'object' && obj['_field_name'])
									{
										obj['_errMsg'] = ''
									}
								})
							}
						})
					}
				},

				//=============================================================
				// событие: потеря фокуса полем формы
				//=============================================================
				onFormBlur(field, formData) {
					this.form_ErrorMessage = false
				},

				//=============================================================
				// событие: клавишы по полю
				//=============================================================
				onFormEnterKeyDown(e) {
					if (e) e.preventDefault()

					this.form_ErrorMessage = false
					this.enterOnInput(e)
				},

				//=============================================================
				// парсит данные формы
				//=============================================================
				parseFormData: function(data, oldData) {
					// инициализируем объект
					let formData = {}

					// если нет данных для парсинга - конец
					if (!data || typeof data !== 'object' || !Object.keys(data).length) return formData

					// это точно данные по форме?
					if (!('status' in data) || data['status'] !== 'form') return formData

					// заголовок
					if ('title' in data) formData['title'] = data['title']
					else formData['title'] = false

					// модель
					if ('model' in data) formData['model'] = data['model']
					else formData['model'] = false

					// поля
					if ('fields' in data && data['fields'] && Object.keys(data['fields']).length) formData['fields'] = Helper.sortByProp(data['fields'], 'order', false, data['model'])
					else formData['fields'] = false

					// если есть старые данные
					if (oldData && typeof oldData === 'object' && 'fields' in oldData && oldData['fields'])
					{
						// если есть поля
						if (formData['fields'] && Array.isArray(formData['fields']) && formData['fields'].length)
						{
							// пробежимся по ним
							formData['fields'].forEach(row => {
								if (row && Array.isArray(row) && row.length)
								{
									row.forEach(field => {
										if (field && typeof field === 'object' && '_field_name' in field)
										{
											// если есть старые данные
											if (oldData['fields'] && Array.isArray(oldData['fields']) && oldData['fields'].length)
											{
												// пробежимся по ним
												oldData['fields'].forEach(oldRow => {
													if (oldRow && Array.isArray(oldRow) && oldRow.length)
													{
														oldRow.forEach(oldField => {
															if (oldField && typeof oldField === 'object' && '_field_name' in oldField &&
																oldField['_field_name'] === field['_field_name'])
															{
																// если есть значение
																if ('value' in oldField)
																{
																	field['value'] = oldField['value']
																}

																// если есть ошибка
																if ('_errMsg' in oldField)
																{
																	field['_errMsg'] = oldField['_errMsg']
																}
															}
														})
													}
												})
											}
										}
									})
								}
							})
						}
					}

					// csrf
					if ('_csrf' in data && data['_csrf']) formData['_csrf'] = data['_csrf']
					else formData['_csrf'] = false

					return formData
				},

				//=============================================================
				// поиск поля форма
				//=============================================================
				findFormField(name, fields) {
					// если нет вообще полей
					if (!fields || !fields.length) return null

					// поля есть - пробежимся по ним
					let _field = null
					fields.some(item => {
						if (item && Array.isArray(item) && item.length)
						{
							item.some(obj => {
								if (obj && obj['_field_name'] === name)
								{
									_field = obj
									return true
								}
							})

							if (_field) return true
						}
					})

					return _field
				},

				//=============================================================
				// локальная проверка поля формы
				//=============================================================
				localFormValidation(field) {
					// проверяем только определенные типы
					// если поле невидно - то и проверять нет смысла, передаваться будет как есть
					if (!field['_visible']) return true
					// если значение поля не задано - то и проверять нет смысла, передаваться будет как есть
					if (field['value'] === undefined || field['value'] === null) return true

					// INTEGRE
					if (field.type === 'integer' || field.type === 'int')
					{
						// получим значение в виде строки
						let v = String(field.value).trim()
						// уберем пробелы
						v = v.replace(/ /g, '')
						// парсим в INT
						let r = parseInt(v)
						// если не удалось
						if (isNaN(r))
						{
							field['_errMsg'] = 'validators/error_int'
							return false
						}

						// если значение не изменилось
						if (v === String(r)) return true
						// значение изменилось
						field['_errMsg'] = 'validators/error_int'
						return false
					}

					// FLOAT || MONEY
					if (field.type === 'float' || field.type === 'money')
					{
						// получим значение в виде строки
						let v = String(field.value).trim()
						// уберем пробелы
						v = v.replace(/ /g, '')
						// парсим в FLOAT
						let r = parseFloat(v)
						// если не удалось
						if (isNaN(r))
						{
							field['_errMsg'] = 'validators/error_float'
							return false
						}

						// доп.проверка
						if (!Helper.isNumeric(String(r)))
						{
							// значение не число
							field['_errMsg'] = 'validators/error_float'
							return false
						}
					}

					// EMAIL
					if (field.type === 'email')
					{
						if (Helper.validateEmail(field.value)) return true
						// проверка не пройдена
						field['_errMsg'] = 'validators/error_email'
						return false
					}

					// для остальных типов все ОК
					return true
				},

				//=============================================================
				// сбор данных для формы
				//=============================================================
				collectFormData(rows, localValidationFunc, crud) {
					// обнуляем данные
					let data = {}

					// смотрим каждое поле простым циклом - что бы прервать его в любой момент
					for (let idx in rows)
					{
						// если нет значения - пропускаем
						if (!rows[idx] || !Array.isArray(rows[idx])) continue

						// бежим по всей строке формы
						let row = rows[idx]
						for (let k in row)
						{
							// получим объект - поле
							let field = row[k]

							// рассматриваем только поля с наименованиями
							if (!field['_field_name']) continue

							// если есть хотя бы одно видимое поле с ошибкой - прерываем
							if (field['_errMsg'] && field['_visible'])
							{
								return false
							}

							// значение по умолчанию
							let _val = field['value']

							// если это "file" или "image"
							if (field['type'] === 'file' || field['type'] === 'image')
							{
								// если есть метка удаления файла
								if (field['_deleteFile'] === true)
								{
									// добавляем еще параметр
									data[field['_field_name'] + '_delete'] = 1
								}

								// если это одиночное значение
								if (field['multifile'] !== true)
								{
									// если задан URl - значит ничего нового не задавали, не нужно пересылать это
									if (_val && (_val.indexOf('.') > -1 || _val.indexOf('/') > -1)) _val = null
								}
							}

							// если это массив
							if (Array.isArray(field['value']))
							{
								// если это пустой массив
								if (!field['value'].length) _val = null
								else
								{
									// масив имеет значения
									_val = []
									// бежим по нему, для конвертации
									field['value'].forEach(item => {
										// если элемент массива - это объект c id
										if (typeof item === 'object' && item['id'])
										{
											_val.push(item['id'])
										}
										// если простой тип
										else _val.push(item)
									})
								}
							}

							// обязательное поле?
							if (field['required'] === true && field['_visible'])
							{
								// если значение вообще не задано
								if (_val === undefined || _val === null)
								{
									field['_errMsg'] = 'error/required_field'
									return false
								}

								// если это пустой массив
								if (Array.isArray(_val) && _val.length === 0)
								{
									field['_errMsg'] = 'error/required_field'
									return false
								}
							}

							// локальная проверка
							if (!localValidationFunc(field))
							{
								// сообщение уже записано
								return false
							}

							// если пустые поля
							if (_val === undefined || _val === null)
							{
								// если это поле массива - все равно передаем
								if (/^\w+\[\w+\]/i.test(field['_field_name']))
									data[field['_field_name']] = ''
								// остальное игнорируем
								continue
							}

							// если это неиспользуемое значение в списке
							if (field['type'] === 'list' && String(_val) === '-1000')
							{
								continue
							}

							// частный случай если это создание внешнего диска
							if (crud === 'disks')
							{
								// если поле "options" не включено - не передаем его
								if (field['_field_name'] === 'options' && !field['required'] && !_val)
								{
									continue
								}
								if (!field['_visible'] && !field['required'])
								{
									continue
								}
							}

							// конвертация значения
							if (field['type'] === 'boolean')
								_val = Helper.normalizeBooleanValue(_val) ? 1 : 0

							// все проверки пройдены - запоминаем значение
							data[field['_field_name']] = _val
						}
					}

					// возвращаем полученный ответ
					return data
				},

				//=============================================================
				// NameForm[data[disk]] => NameForm[data][disk]
				//=============================================================
				FormDataRePack(data) {
					let k
					let n1
					let n2
					let key1
					let key2

					for (k in data) if (data.hasOwnProperty(k))
					{
						n1 = k.indexOf('[')
						if (n1 < 0) continue

						n2 = k.indexOf(']', n1)
						if (n2 < 0) continue

						key1 = k.substr(0, n1)
						key2 = k.substring(n1 + 1, n2)

						if (n2 + 1 < k.length) key2 += k.substr(n2 + 1)

						if (!data[key1]) data[key1] = {}

						data[key1][key2] = data[k]

						delete data[k]

						data[key1] = this.FormDataRePack(data[key1])
					}

					return data
				},

				//=============================================================
				// проверка прав
				//=============================================================
				isAccess: function(url) {
					// проверка параметра
					if (!url) return false
					if (url === '/404' || url === '/500' || url === '/503' || url === '/user/check' || url === '/email/check') return true

					// доступ к профилю есть всегда и у всех
					if (url === 'options' || url === '/options') return true
					// доступ к CRUD email есть всегда и у всех
					if (url.indexOf('/email/') === 0) return true
					// доступ к вкладками VDS есть всегда
					if (/vds\/\d+\/list/.test(url)) return true
					// доступ к вкладками по тикетам у сотрудников есть всегда
					if (url.indexOf('ticket/department') !== -1 && this.$store.state.user_type === 'admin') return true

					// по умолчанию - доступ запрещен
					let _access = false

					// получим действие, на которое требуется разрешение
					let _parts = url.split('/')
					let _crud = ''
					let _action = ''
					let _param = ''
					// если пуст начинается с '/'
					if (url.charAt(0) === '/')
					{
						_crud = _parts[1]
						_action = _parts[2]
						_param = _parts[3] ? _parts[3] : ''
					}
					// если путь без начального слеша
					else
					{
						_crud = _parts[0]
						_action = _parts[1]
						_param = _parts[2] ? _parts[2] : ''
					}

					// если это VDS
					if (_crud === 'vds' && /^\d+$/.test(_action) && /^\w+$/.test(_param))
					{
						let _temp = _action
						_action = _param
						_param = _temp
					}

					// action может получиться с параметрами: /ticket/list?TicketSearch[ticket_date_start]=2018-06-01
					if (_action.indexOf('?') > -1)
						// а нам нужен чистый action
						_action = _action.substring(0, _action.indexOf('?'))

					// если это клиент - то почти все разрешено
					if (this.$store.state.user_type === 'client')
					{
						// просмотр тикетов запрещен
						if (_crud === 'ticketmessage') return false
						// просмотр IP-пулов запрещен
						if (_crud === 'ippool') return false
						// просмотр Шаблонов запрещен
						if (_crud === 'template') return false
						// просмотр Тарифов запрещен
						if (_crud === 'plan') return false
						//return true
					}

					// получим реальный CRUD
					_crud = this.getRealCrud(_crud)

					// частные случаи
					// настройка уведомлений - бывшее _action = 'update'
					if (_crud === 'user' && _action === 'alerts') return true
					if (_crud === 'dashboard' && _action === 'info')
					{
						_crud = 'account'
						_action = 'view'
					}
					if (_crud === 'qa' && _action === 'list')
					{
						return true
					}
					// chart
					if (_crud === 'chart')
					{
						if (_param !== '')
						{
							// если такое действие есть в массив разрешенных действий
							if (this.$store.state.user_role &&
								this.$store.state.user_role.permissions && Array.isArray(this.$store.state.user_role.permissions) &&
								this.$store.state.user_role.permissions.indexOf(_crud + '/' + _param) !== -1)
								return true
						}
						else
						{
							// если такое действие есть в массив разрешенных действий
							if (this.$store.state.user_role &&
								this.$store.state.user_role.permissions && Array.isArray(this.$store.state.user_role.permissions) &&
								this.$store.state.user_role.permissions.indexOf(_crud + '/list') !== -1)
								return true
						}

						return false
					}

					// если такое действие есть в массив разрешенных действий
					if (this.$store.state.user_role &&
						this.$store.state.user_role.permissions && Array.isArray(this.$store.state.user_role.permissions) &&
						this.$store.state.user_role.permissions.indexOf(_crud + '/' + _action) !== -1)
						_access = true
					// вернем полученный результат
					return _access
				},

				//=============================================================
				// получение домена, с которого пришел пользователь
				//=============================================================
				getReferrer() {
					this.Referrer = false
					let r = document.referrer
					if (r && r !== '')
					{
						r = new URL(r).hostname.split('.')
						if (r.length >= 2) this.Referrer = r[r.length - 2] + '.' + r[r.length - 1]
						else this.Referrer = r[0]
					}
				},

				//=============================================================
				// проверка на публичные страницы
				//=============================================================
				isPublicUrl(Url) {
					let urls = [
						'/login',
						'/register',
						'/forget',
						'/user/forget',
						'/user/check',
						'/email/check',
						'/unsubscribe*',
						'/503',
						'/operation/select/*',
						'/operation/pay/*',
						'/operation/view/*',
						'/operation/list'
					]

					return urls.some(item => {
						// нестрогое сравнение
						if (item.indexOf('*'))
						{
							let path = item.replace(/\*/g, '')
							if (Url.indexOf(path) === 0)
								return true
						}
						// строгое сравнение
						else
						{
							if (item === Url)
								return true
						}
					})
				},

				//=============================================================
				// форматирование денег
				//=============================================================
				moneyOnlyNumbers(value) {
					if (value === null || value === undefined) return '0'
					value = Helper.FormatMoney2(value, 2)
					return Helper.String2Money(value)
				}

				//=============================================================
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		})

		//---------------------------------------------------------------------
		// директивы
		//---------------------------------------------------------------------
		// вешает обработчик, который ловит клик вне элемента
		Vue.directive('click-outside', {
			bind(el, binding, vnode) {
				el.__eventClickOutSide__ = function(event) {
					if (!(el === event.target || el.contains(event.target)))
					{
						vnode.context[binding.expression](event)
					}
				}
				document.body.addEventListener('click', el.__eventClickOutSide__)
			},
			unbind(el) {
				document.body.removeEventListener('click', el.__eventClickOutSide__)
			}
		})

		// ищет строку и обрамлет ее в блок
		Vue.directive('highlightFastSearch', {
			inserted: function(el, binding) {
				// если строка поиска не задана
				let searchString = binding.value
				if (searchString === null || searchString === undefined || searchString === '') return

				let Text = el.innerHTML
				let text = String(Text)

				// обрамление по умолчанию
				let before = '<strong class="w5-selected-text">'
				let after = '</strong>'

				let findString = window.findStringEscape(searchString)

				// далем обрамление и возвращаем текст
				el.innerHTML = text.replace(new RegExp(findString, 'ig'), function(str, offset, s) {
					let isNeedBorders = true
					for (let i = offset + findString.length; i < s.length; i++) {
						if (s[i] === '>') {
							isNeedBorders = false
							break
						}
					}

					return isNeedBorders
						? before + str + after
						: str
				})
			}
		})

		// меняет символы в теги
		Vue.directive('withSafeTags', {
			inserted: function(el, binding) {
				const text = String(binding.value)
				const className = String(el.className)

				// далем обрамление и возвращаем текст
				el.innerHTML = Helper.safe_tags_replace(text)
					// <b> </b>
					.replace(/&lt;b&gt;/ig, '<strong>').replace(/&lt;\/b&gt;/ig, '</strong>')
					// <p> </p>
					.replace(/&lt;p&gt;/ig, '<p>').replace(/&lt;\/p&gt;/ig, '</p>')
					// <w> </w>
					.replace(/&lt;w&gt;/ig, '<span style="color: red">').replace(/&lt;\/w&gt;/ig, '</span>')
					// <pswdr> </pswdr>
					.replace(/&lt;pswdr&gt;/ig, `<span id="instruction-password-value" style="font-size: 14px;${className.indexOf('instruction-password shown') > 0 ? '' : 'color: #ccc'}">`)
					.replace(/&lt;\/pswdr&gt;/ig, '</span>' + Helper.htmlInstructionPasswordButton(className))
					// <i> </i>
					.replace(/&lt;i&gt;/ig, '<i>').replace(/&lt;\/i&gt;/ig, '</i>')
					// <u> </u>
					.replace(/&lt;u&gt;/ig, '<u>').replace(/&lt;\/u&gt;/ig, '</u>')
					// <ul> </ul>
					.replace(/&lt;ul&gt;/ig, '<ul>').replace(/&lt;\/ul&gt;/ig, '</ul>')
					// <li> </li>
					.replace(/&lt;li&gt;/ig, '<li>').replace(/&lt;\/li&gt;/ig, '</li>')
					// <a></a>
					.replace(/&lt;a(.*)&gt;(.*)&lt;\/a&gt;/ig, (str, p1, p2, offset, s) => {
						return '<a ' + p1.replace(/&quot;/ig, '"').replace(/&#39;/ig, '\'') + '>' + p2 + '</a>'
					})
					// <br>
					.replace(/&lt;br&gt;/ig, '<br>')
					// <br/>
					.replace(/&lt;br\/&gt;/ig, '<br/>')
					// ₽
					.replace(/&amp;#8381;/ig, '₽')
					// &nbsp;
					.replace(/&amp;nbsp;/ig, '&nbsp;')
			},
			update: function(el, binding) {
				const text = String(binding.value)
				const className = String(el.className)
				let old = String(binding.oldValue)
				if (old === text) return
				// далем обрамление и возвращаем текст
				el.innerHTML = Helper.safe_tags_replace(text)
					// <b> </b>
					.replace(/&lt;b&gt;/ig, '<strong>').replace(/&lt;\/b&gt;/ig, '</strong>')
					// <p> </p>
					.replace(/&lt;p&gt;/ig, '<p>').replace(/&lt;\/p&gt;/ig, '</p>')
					// <w> </w>
					.replace(/&lt;w&gt;/ig, '<span style="color: red">').replace(/&lt;\/w&gt;/ig, '</span>')
					// <pswdr> </pswdr>
					.replace(/&lt;pswdr&gt;/ig, `<span id="instruction-password-value" style="font-size: 14px;${className.indexOf('instruction-password shown') > 0 ? '' : 'color: #ccc'}">`)
					.replace(/&lt;\/pswdr&gt;/ig, '</span>' + Helper.htmlInstructionPasswordButton(className))
					// <i> </i>
					.replace(/&lt;i&gt;/ig, '<i>').replace(/&lt;\/i&gt;/ig, '</i>')
					// <u> </u>
					.replace(/&lt;u&gt;/ig, '<u>').replace(/&lt;\/u&gt;/ig, '</u>')
					// <ul> </ul>
					.replace(/&lt;ul&gt;/ig, '<ul>').replace(/&lt;\/ul&gt;/ig, '</ul>')
					// <li> </li>
					.replace(/&lt;li&gt;/ig, '<li>').replace(/&lt;\/li&gt;/ig, '</li>')
					// <a></a>
					.replace(/&lt;a(.*)&gt;(.*)&lt;\/a&gt;/ig, (str, p1, p2, offset, s) => {
						return '<a ' + p1.replace(/&quot;/ig, '"').replace(/&#39;/ig, '\'') + '>' + p2 + '</a>'
					})
					// <br>
					.replace(/&lt;br&gt;/ig, '<br>')
					// <br/>
					.replace(/&lt;br\/&gt;/ig, '<br/>')
					// ₽
					.replace(/&amp;#8381;/ig, '₽')
					// &nbsp;
					.replace(/&amp;nbsp;/ig, '&nbsp;')
			}
		})

		// форматирует сообщение тикета
		Vue.directive('formatTicketMessage', {
			inserted: function(el, binding) {
				// должен быть задан объект
				let _obj = binding.value
				// если это что-то другое - ничего не делаем
				if (!_obj || typeof _obj !== 'object' || !_obj['message']) return
				// получим объект сообщения
				let _msg = _obj['message']
				// если это не он - ничего не делаем
				if (!_msg || typeof _msg !== 'object' || _msg['message_content_type'] !== 'plain' || !_msg['message_content']) return

				// форматируем текст сообщения
				let _txt = ''
				try {
					_txt = Helper.formatTicketMessage(_msg['message_content'], _obj['fastSearchValue'], _msg['message_type'] === 'notice')
				}
				catch (err) {
					_txt = null
				}
				// упрощенное форматирование
				if (_txt === null)
				{
					try {
						_txt = Helper.escapeHtml(_msg['message_content'])
						_txt = Helper.nl2br(_txt)
					}
					catch (eerr)
					{
						_txt = ''
					}
				}
				el.innerHTML = _txt
			},
			update: function(el, binding) {
				// должен быть задан объект
				let _obj = binding.value
				// если это что-то другое - ничего не делаем
				if (!_obj || typeof _obj !== 'object' || !_obj['message']) return
				// получим объект сообщения
				let _msg = _obj['message']
				// если это не он - ничего не делаем
				if (!_msg || typeof _msg !== 'object' || _msg['message_content_type'] !== 'plain' || !_msg['message_content']) return

				// старое значение и новое
				let _old = el.innerHTML
				let _new = ''
				try {
					_new = Helper.formatTicketMessage(_msg['message_content'], _obj['fastSearchValue'], _msg['message_type'] === 'notice')
				}
				catch (err) {
					_new = null
				}
				// упрощенное форматирование
				if (_new === null)
				{
					try {
						_new = Helper.escapeHtml(_msg['message_content'])
						_new = Helper.nl2br(_new)
					}
					catch (eerr)
					{
						_new = ''
					}
				}
				// если они не равны - обновляем
				if (_old !== _new)
					el.innerHTML = _new
			}
		})

		//---------------------------------------------------------------------
		// фильтры
		//---------------------------------------------------------------------
		Vue.filter('capitalize', function(value) {
			if (!value) return ''

			let _words = String(value).split(' ')
			let _cap = _words.map((word, index) => {
				// если это слово из всех заглавных - сохраняем его как есть
				if (word === word.toLocaleUpperCase()) return word

				// по умолчанию просто приводим слово к нижнему регистру
				let _str = word.toLowerCase()

				// если это первое слово
				if (index === 0)
					// капитализируем его
					return _str.charAt(0).toUpperCase() + _str.slice(1)

				// по умолчанию просто отправляем в нижнем регистре
				return _str
			})

			return _cap.join(' ')
		})

		Vue.filter('lower', function(value, needIgnore) {
			if (needIgnore) return value
			if (!value) return ''
			value = value.toString()
			return value.toLowerCase()
		})

		Vue.filter('upper', function(value, needIgnore) {
			if (needIgnore) return value
			if (!value) return ''
			value = value.toString()
			return value.toUpperCase()
		})

		Vue.filter('trim', function(value) {
			if (!value) return ''
			value = value.toString()
			return value.trim()
		})

		Vue.filter('money', function(value) {
			if (value === null || value === undefined) return '0'
			value = Helper.FormatMoney(value)
			return value
		})

		Vue.filter('money2', function(value) {
			if (value === null || value === undefined) return '0'
			value = Helper.FormatMoney2(value, store.state.user_type === 'admin' ? -1 : 2)
			return value
		})

		Vue.filter('money_1', function(value, digits = -1) {
			if (value === null || value === undefined) return '0'
			value = Helper.FormatMoney2(value, digits)
			return value
		})

		Vue.filter('money02', function(value) {
			if (value === null || value === undefined) return '0'
			value = Helper.FormatMoney2(value, 2)
			return value
		})

		Vue.filter('moneyOnlyNumbers', function(value) {
			if (value === null || value === undefined) return '0'
			value = Helper.FormatMoney2(value, 2)
			return Helper.String2Money(value)
		})

		Vue.filter('bytes', function(value) {
			value = Helper.FormatBytes(value)
			return value
		})

		Vue.filter('date', function(value, format) {
			value = Helper.FormatDateTime(value, format)
			return value
		})

		Vue.filter('ftc', function(str) {
			// проверка входного параметра
			if (str === null || str === undefined || str === '') return ''
			if (str === true || str === 'true') return Vue.localeBase['main/yes']
			if (str === false || str === 'false') return Vue.localeBase['main/no']

			// приведение к типу String и разбивка на части и подстановка данных из словаря
			return String(str).split(' ').map(function(s) {
				// находим паттерн
				// eslint-disable-next-line
				let m = s.match(/[a-z\-]+\/\w+/)
				// если нашли
				if (m !== null) return m in Vue.localeBase && Vue.localeBase[m] ? s.replace(m, Vue.localeBase[m]) : s

				// пробуем чуть-чуть другой паттерн
				m = s.match(/\w+\/\w+/)
				// если нашли
				if (m !== null) return m in Vue.localeBase && Vue.localeBase[m] ? s.replace(m, Vue.localeBase[m]) : s

				// если не нашли
				return s in Vue.localeBase && Vue.localeBase[s] ? Vue.localeBase[s] : s
			}).join(' ')
		})

		Vue.filter('rub', function(str) {
			// проверка входного параметра
			if (str === null || str === undefined || str === '') return ''

			return str.replace(/&#8381;/ig, '₽')
		})

		//---------------------------------------------------------------------
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
export default formsPlugin
///////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// ./src/plugins/forms.js